import type { PropsWithChildren } from "react";

import Typography from "@/design-system/Typography";
import Button from "@/design-system/button";
import type { PropsWithStyleX } from "@stylex/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

import { ComposableSpacing, colors } from "../../styles/tokens.stylex";

export interface IFavoritesItem extends PropsWithChildren<PropsWithStyleX> {
    title: string;
    noResultsText?: string;
    linkHref: string;
    linkText: string;
}

export default function FavoriteItem(props: IFavoritesItem) {
    return (
        <div {...stylex.props(styles.favoriteItemContainer, props.styleX)}>
            <Typography textElement="h4" fontStyle="hS">
                {props.title}
            </Typography>

            {props.noResultsText ? (
                <Typography fontStyle="hS" styleX={styles.emptyResult}>
                    {props.noResultsText}
                </Typography>
            ) : (
                props.children
            )}

            <Button as="a" variant="transparent" href={props.linkHref} size="M" styleX={styles.link}>
                {props.linkText}
            </Button>
        </div>
    );
}
const styles = stylex.create({
    favoriteItemContainer: {
        gap: ComposableSpacing.s6,
        display: "flex",
        flexDirection: "column",
    },

    link: {
        color: colors.fg_BrandBlue,
        marginBottom: 0,
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: 0,
    },

    emptyResult: {
        borderColor: colors.b_centas,
        borderRadius: ComposableSpacing.s1,
        borderStyle: "solid",
        borderWidth: 1,

        textAlign: "center",
        paddingBottom: ComposableSpacing.s8,
        paddingTop: ComposableSpacing.s8,
    },
});
